export interface components {
    schemas: {
        AgeGroupType: AgeGroupType;
        ApplicationModel: {
            amount?: number;
            applicationId: string;
            applicationStatus: ApplicationModelApplicationStatus;
            applicationType: ApplicationModelApplicationType;
            createdDate: string;
            equity: number;
            lastUpdatedDate?: string;
            loanPurpose?: ApplicationModelLoanPurpose;
            mainSecurityAddress?: string;
            paidOutDate?: string;
            paymentPeriod?: number;
            securityValue?: number;
            submittedDate: string;
            totalCostsFirstTerm?: number;
            validUntilDate?: string;
        };
        ErrorDto: {
            errorCode?: string;
            errorMessage?: string;
        };
        ErrorResponse: {
            errors?: components["schemas"]["ErrorDto"][];
        };
        EstateModel: {
            loan?: components["schemas"]["LoanModel"];
            security?: components["schemas"]["SecurityModel"];
        };
        EstimateModel: {
            date?: string;
            dayOffset?: number;
            estimate?: number;
            origin?: EstimateModelOrigin;
            priceType?: EstimateModelPriceType;
        };
        FundTransfer: {
            country: string;
            numberOfTransfers: number;
            otherTransferReason?: string;
            totalAmount: number;
            transferReasons: components["schemas"]["FundTransferReasonType"][];
        };
        FundTransferReasonType: FundTransferReasonType;
        Income: {
            incomeBeforeTax: number;
            sourceOfIncome: components["schemas"]["SourceOfIncome"];
        };
        LoanInExternalInstitutionInputModel: {
            institutionOrganizationNumber: string;
            loanBalance: number;
        };
        LoanInstitutionOutputModel: {
            name: string;
            organizationNumber?: string;
        };
        LoanModel: {
            additionalSecurities?: string[];
            currentInterestRate?: number;
            effectiveInterestRate?: number;
            institution?: components["schemas"]["LoanInstitutionOutputModel"];
            interestsFirstTerm?: number;
            loanToValueRatio?: number;
            nextPaymentAmount?: number;
            nextPaymentDate?: string;
            origin: LoanModelOrigin;
            paidAmount?: number;
            paymentFirstTerm?: number;
            remainingAmount?: number;
            termFees?: number;
        };
        OnBehalfOfOthers: {
            email: string;
            fullName: string;
            ninOrOrgNr: string;
            phoneNumber: string;
            purpose: string;
            relation: string;
        };
        PersonCitizenshipModel: {
            countryCode?: string;
            countryName?: string;
            sourceOfCitizenship?: components["schemas"]["SourceOfCitizenship"];
        };
        PersonModel: {
            address?: string;
            email?: string;
            firstName?: string;
            fullName?: string;
            lastName?: string;
            nin?: string;
            phone?: string;
        };
        PersonPUMResponseModel: {
            ageGroupType?: components["schemas"]["AgeGroupType"];
            citizenshipCountries?: components["schemas"]["PersonCitizenshipModel"][];
            firstName?: string;
            id?: string;
            lastName?: string;
            legitimizeStatus?: PersonPUMResponseModelLegitimizeStatus;
            productTypes?: components["schemas"]["ProductType"][];
        };
        ProductType: ProductType;
        PurposeOfAccount: PurposeOfAccount;
        SecurityModel: {
            address?: string;
            areaMarketScore?: number;
            buildYear?: number;
            energyLabelColor?: string;
            energyLabelLetter?: string;
            estateType?: string;
            estimates?: components["schemas"]["EstimateModel"][];
            hasCollateralInStorebrand?: boolean;
            id?: string;
            lastSalePrice?: number;
            livingArea?: number;
            municipality?: string;
            municipalityScore?: number;
            ownerShip?: string;
            postcodeArea?: string;
            valueIncreasedAmount?: number;
            valueIncreasedPercent?: number;
        };
        SelfServiceBankAccessToForeignPaymentsModel: {
            amountPerYear: number;
            countryCode: string;
            countryName: string;
            foreignPaymentAccessReason: SelfServiceBankAccessToForeignPaymentsModelForeignPaymentAccessReason;
            numberOfTransactionsPerYear: number;
            otherReason?: string;
            selfServiceType?: SelfServiceBankAccessToForeignPaymentsModelSelfServiceType;
        };
        SelfServiceBankAccountForChildModel: {
            childAmlModel: components["schemas"]["SelfServiceBankChildAmlModel"];
            childPhoneNumber: string;
            citizenshipCountries: string[];
            productType: components["schemas"]["ProductType"][];
            secondParentEmail: string;
            secondParentFullName: string;
            secondParentPhoneNumber: string;
            selfServiceType?: SelfServiceBankAccountForChildModelSelfServiceType;
            userComment?: string;
        };
        SelfServiceBankAccountModel: {
            accountAlias?: string;
            accountBalance?: number;
            accountName: string;
            accountNumber: string;
        };
        SelfServiceBankAccountStatementDeliveryAddress: {
            city: string;
            postalCode: string;
            streetAddress: string;
        };
        SelfServiceBankChildAmlModel: {
            accountPurpose: components["schemas"]["PurposeOfAccount"][];
            bankingOnBehalfOfOthers: boolean;
            fundTransfers: components["schemas"]["FundTransfer"][];
            incomes: components["schemas"]["Income"][];
            isUsTaxable: boolean;
            onBehalfOfOthers?: components["schemas"]["OnBehalfOfOthers"][];
            usSocialSecurityNumber: string;
            willReceiveMoneyFromAbroad: boolean;
        };
        SelfServiceBankCloseAccountModel: {
            consentToCloseAccount: boolean;
            newAccountNumber: string;
            selfServiceBankAccountModels: components["schemas"]["SelfServiceBankAccountModel"][];
            selfServiceType?: SelfServiceBankCloseAccountModelSelfServiceType;
        };
        SelfServiceBankIdForChildModel: {
            secondParentEmail: string;
            secondParentFullName: string;
            secondParentPhoneNumber: string;
            selfServiceType?: SelfServiceBankIdForChildModelSelfServiceType;
            userComment?: string;
        };
        SelfServiceBankOrderAccountStatements: {
            accountForFeeDeduction: string;
            accountNumbers: string[];
            consentForFeeDeduction: boolean;
            deliveryAddress?: components["schemas"]["SelfServiceBankAccountStatementDeliveryAddress"];
            deliveryMethod: SelfServiceBankOrderAccountStatementsDeliveryMethod;
            email: string;
            endDate: string;
            fromDate: string;
            selfServiceType?: SelfServiceBankOrderAccountStatementsSelfServiceType;
        };
        SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModel: {
            certificateType: SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModelCertificateType;
            consentForGoodnessOrCustomerDeclaration: boolean;
            feeDeductionAccountNumber: string;
            selfServiceType?: SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModelSelfServiceType;
            userComment?: string;
        };
        SelfServiceBankOrderPUMModel: {
            address: string;
            email: string;
            fullName: string;
            location: string;
            phoneNumber: string;
            postalCode: string;
            selfServiceType?: SelfServiceBankOrderPUMModelSelfServiceType;
        };
        SelfServiceBankPUMForChildModel: {
            address: string;
            email: string;
            fullName: string;
            location: string;
            phoneNumber: string;
            postalCode: string;
            selfServiceType?: SelfServiceBankPUMForChildModelSelfServiceType;
        };
        SelfServiceBankRenewFixedRateDepositInputModel: {
            fixedRateDepositAccounts: components["schemas"]["SelfServiceBankRenewFixedRateDepositOutputModel"][];
            renewalPeriod: components["schemas"]["SelfServiceRenewAccountFrequency"];
            selfServiceType?: SelfServiceBankRenewFixedRateDepositInputModelSelfServiceType;
        };
        SelfServiceBankRenewFixedRateDepositOutputModel: {
            accountAlias?: string;
            accountBalance?: number;
            accountName: string;
            accountNumber: string;
            expiryDate?: string;
        };
        SelfServiceBankSharedAccountModel: {
            disponentIsBankCustomer?: boolean;
            disponentName: string;
            disponentNin: string;
            needExtraBankCard: boolean;
            principalOwnerName?: string;
            principalOwnerNin?: string;
            selfServiceBankAccountModels: components["schemas"]["SelfServiceBankAccountModel"][];
            selfServiceType?: SelfServiceBankSharedAccountModelSelfServiceType;
        };
        SelfServiceBankSwitchModel: {
            accountNumbers: string[];
            consentForBankSwitch: boolean;
            selfServiceType?: SelfServiceBankSwitchModelSelfServiceType;
            switchToAccountNumber: string;
        };
        SelfServiceBankTerminateBSUAccountModel: {
            bsuAccountNumber: string;
            bsuAccountTerminateReason: SelfServiceBankTerminateBSUAccountModelBsuAccountTerminateReason;
            bsuAccountTransferOption: SelfServiceBankTerminateBSUAccountModelBsuAccountTransferOption;
            consentToCloseAccount: boolean;
            fileMetaData: components["schemas"]["SelfServiceMetaData"];
            fundTransferDetails: components["schemas"]["SelfServiceFundTransferDetails"];
            selfServiceType?: SelfServiceBankTerminateBSUAccountModelSelfServiceType;
            userComment?: string;
        };
        SelfServiceCreditCardApplicationModel: {
            creditCardAccountNumber?: string;
            creditCardApplicationType: SelfServiceCreditCardApplicationModelCreditCardApplicationType;
            creditCardType: SelfServiceCreditCardApplicationModelCreditCardType;
            currentCarLoan: number;
            currentMortgage: number;
            currentStudentLoan: number;
            estimatedAnnualIncome: number;
            noOfChildrenInDaycare: number;
            noOfChildrenUnder18: number;
            ownsCabin: boolean;
            ownsCar: boolean;
            relationshipStatus: SelfServiceCreditCardApplicationModelRelationshipStatus;
            requestedCreditLimit: number;
            selfServiceType?: SelfServiceCreditCardApplicationModelSelfServiceType;
        };
        SelfServiceCreditCardDetailsModel: {
            creditCardAccountNumber?: string;
            creditCardType?: SelfServiceCreditCardDetailsModelCreditCardType;
            creditLimit?: number;
            outStandingBalance?: number;
        };
        SelfServiceCreditCardTerminateModel: {
            creditCardAccountNumbers: string[];
            creditCardTerminateReason: SelfServiceCreditCardTerminateModelCreditCardTerminateReason;
            selfServiceType?: SelfServiceCreditCardTerminateModelSelfServiceType;
        };
        SelfServiceCreditDecreaseModel: {
            creditCardAccountNumber?: string;
            creditCardApplicationType: SelfServiceCreditDecreaseModelCreditCardApplicationType;
            creditCardType: SelfServiceCreditDecreaseModelCreditCardType;
            requestedCreditLimit: number;
        };
        SelfServiceFundTransferDetails: {
            accountNumber: string;
            bankName?: string;
            kidOrMessage?: string;
            recipientName?: string;
        };
        SelfServiceLoanAccountModel: {
            accountType?: SelfServiceLoanAccountModelAccountType;
            dueDay?: number;
            fixedInterestRate?: boolean;
            hasActiveRepaymentFreePeriod?: boolean;
            loanAccountDescription?: string;
            loanAccountName: string;
            loanAccountNumber: string;
            loanPaymentAccountNumber?: string;
            nextPaymentAmount: number;
            remainingLoanAmount?: number;
            remainingLoanRepaymentPeriod?: number;
            repaymentFreePeriodExpiryDate?: string;
            repaymentFreePeriodStartDate?: string;
        };
        SelfServiceLoanInterestOnlyModel: {
            interestOnlyPeriod: string;
            loanAccounts: components["schemas"]["SelfServiceLoanAccountModel"][];
            reasonForInterestOnly: string;
        };
        SelfServiceLoanPaymentAccountModel: {
            desiredPaymentAccountNumber: string;
            loanAccounts: components["schemas"]["SelfServiceLoanAccountModel"][];
            selfServiceType?: SelfServiceLoanPaymentAccountModelSelfServiceType;
        };
        SelfServiceLoanPaymentAmountModel: {
            confirmationAndConsentForCreditCheck: boolean;
            customerName?: string;
            customerNin?: string;
            desiredPaymentAmount: number;
            loanAccounts: components["schemas"]["SelfServiceLoanAccountModel"][];
            selfServiceType?: SelfServiceLoanPaymentAmountModelSelfServiceType;
        };
        SelfServiceLoanPaymentDateModel: {
            desiredPaymentDateOfMonth: string;
            loanAccounts: components["schemas"]["SelfServiceLoanAccountModel"][];
            selfServiceType?: SelfServiceLoanPaymentDateModelSelfServiceType;
        };
        SelfServiceLoanRepaymentPeriodModel: {
            desiredRepaymentDuration: string;
            loanAccounts: components["schemas"]["SelfServiceLoanAccountModel"][];
            selfServiceType?: SelfServiceLoanRepaymentPeriodModelSelfServiceType;
        };
        SelfServiceMetaData: {
            fileId: string;
            fileName: string;
            token: string;
        };
        SelfServicePaymentAccountModel: {
            paymentAccountName: string;
            paymentAccountNumber: string;
        };
        SelfServiceRenewAccountFrequency: SelfServiceRenewAccountFrequency;
        SelfServiceResponse: {
            createdDateTime?: string;
            selfServiceRequestId?: string;
        };
        SourceOfCitizenship: SourceOfCitizenship;
        SourceOfIncome: SourceOfIncome;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: {
        ClientId: string;
    };
    pathItems: never;
}

// Export below are generated by Typify, DO NOT EDIT !:

type apiTypes = components['schemas'];

export type ApplicationModel = apiTypes['ApplicationModel'];
export type ErrorDto = apiTypes['ErrorDto'];
export type ErrorResponse = apiTypes['ErrorResponse'];
export type EstateModel = apiTypes['EstateModel'];
export type EstimateModel = apiTypes['EstimateModel'];
export type FundTransfer = apiTypes['FundTransfer'];
export type Income = apiTypes['Income'];
export type LoanInExternalInstitutionInputModel = apiTypes['LoanInExternalInstitutionInputModel'];
export type LoanInstitutionOutputModel = apiTypes['LoanInstitutionOutputModel'];
export type OnBehalfOfOthers = apiTypes['OnBehalfOfOthers'];
export type PersonCitizenshipModel = apiTypes['PersonCitizenshipModel'];
export type PersonModel = apiTypes['PersonModel'];
export type PersonPUMResponseModel = apiTypes['PersonPUMResponseModel'];
export type SelfServiceBankAccessToForeignPaymentsModel = apiTypes['SelfServiceBankAccessToForeignPaymentsModel'];
export type SelfServiceBankAccountForChildModel = apiTypes['SelfServiceBankAccountForChildModel'];
export type SelfServiceBankAccountModel = apiTypes['SelfServiceBankAccountModel'];
export type SelfServiceBankCloseAccountModel = apiTypes['SelfServiceBankCloseAccountModel'];
export type SelfServiceBankIdForChildModel = apiTypes['SelfServiceBankIdForChildModel'];
export type SelfServiceBankOrderAccountStatements = apiTypes['SelfServiceBankOrderAccountStatements'];
export type SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModel = apiTypes['SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModel'];
export type SelfServiceBankOrderPUMModel = apiTypes['SelfServiceBankOrderPUMModel'];
export type SelfServiceBankPUMForChildModel = apiTypes['SelfServiceBankPUMForChildModel'];
export type SelfServiceBankRenewFixedRateDepositInputModel = apiTypes['SelfServiceBankRenewFixedRateDepositInputModel'];
export type SelfServiceBankRenewFixedRateDepositOutputModel = apiTypes['SelfServiceBankRenewFixedRateDepositOutputModel'];
export type SelfServiceBankSharedAccountModel = apiTypes['SelfServiceBankSharedAccountModel'];
export type SelfServiceBankSwitchModel = apiTypes['SelfServiceBankSwitchModel'];
export type SelfServiceBankTerminateBSUAccountModel = apiTypes['SelfServiceBankTerminateBSUAccountModel'];
export type SelfServiceCreditCardApplicationModel = apiTypes['SelfServiceCreditCardApplicationModel'];
export type SelfServiceCreditCardDetailsModel = apiTypes['SelfServiceCreditCardDetailsModel'];
export type SelfServiceCreditCardTerminateModel = apiTypes['SelfServiceCreditCardTerminateModel'];
export type SelfServiceCreditDecreaseModel = apiTypes['SelfServiceCreditDecreaseModel'];
export type SelfServiceLoanAccountModel = apiTypes['SelfServiceLoanAccountModel'];
export type SelfServiceLoanInterestOnlyModel = apiTypes['SelfServiceLoanInterestOnlyModel'];
export type SelfServiceLoanPaymentAccountModel = apiTypes['SelfServiceLoanPaymentAccountModel'];
export type SelfServiceLoanPaymentAmountModel = apiTypes['SelfServiceLoanPaymentAmountModel'];
export type SelfServiceLoanPaymentDateModel = apiTypes['SelfServiceLoanPaymentDateModel'];
export type SelfServiceLoanRepaymentPeriodModel = apiTypes['SelfServiceLoanRepaymentPeriodModel'];
export type SelfServicePaymentAccountModel = apiTypes['SelfServicePaymentAccountModel'];
export type SelfServiceResponse = apiTypes['SelfServiceResponse'];

export enum AgeGroupType {
    CHILD_UNDER_7 = "CHILD_UNDER_7",
    CHILD_BETWEEN_7_AND_14 = "CHILD_BETWEEN_7_AND_14",
    CHILD_AGED_14 = "CHILD_AGED_14",
    CHILD_15_OR_OLDER = "CHILD_15_OR_OLDER"
}
export enum ApplicationModelApplicationStatus {
    OPEN = "OPEN",
    SUBMITTED = "SUBMITTED",
    ADVISOR = "ADVISOR",
    REVIEW = "REVIEW",
    VALIDATE = "VALIDATE",
    CONTROL = "CONTROL",
    NOTAPPROVED = "NOTAPPROVED",
    APPROVED = "APPROVED",
    OFFER = "OFFER",
    PRODUCTION = "PRODUCTION",
    PAPERSIGNATURE = "PAPERSIGNATURE",
    ESIGNATURE = "ESIGNATURE",
    PAYMENTOSLO = "PAYMENTOSLO",
    PAYMENTBALTIC = "PAYMENTBALTIC",
    PAYEDOUT = "PAYEDOUT",
    REJECTED = "REJECTED",
    CLOSED = "CLOSED",
    AUTO_APPROVED = "AUTO_APPROVED",
    EVALUATING = "EVALUATING",
    SENDING = "SENDING",
    ESIGNATURE_REQUESTED = "ESIGNATURE_REQUESTED",
    DOCUMENT_RECEIVED = "DOCUMENT_RECEIVED",
    ESIGNATURE_READY = "ESIGNATURE_READY",
    RECEIVED_SIGNED_DOCUMENTS = "RECEIVED_SIGNED_DOCUMENTS",
    MANUAL_PRODUCTION = "MANUAL_PRODUCTION",
    ESIGNATURE_SIGNED = "ESIGNATURE_SIGNED",
    SDC_MANUAL = "SDC_MANUAL",
    PAID_OUT = "PAID_OUT",
    ONBOARDING = "ONBOARDING",
    BANK_INFO_ADDED = "BANK_INFO_ADDED",
    EVALUATING_MANUALLY = "EVALUATING_MANUALLY"
}
export enum ApplicationModelApplicationType {
    REFINANCING = "REFINANCING",
    NEW_LOAN = "NEW_LOAN",
    BID_LOAN = "BID_LOAN",
    ADJUST_LOAN = "ADJUST_LOAN",
    CONSUMER_LOAN = "CONSUMER_LOAN",
    REFINANCING_CONSUMER_LOAN = "REFINANCING_CONSUMER_LOAN",
    CREDIT_CARD = "CREDIT_CARD"
}
export enum ApplicationModelLoanPurpose {
    REFINANCING = "REFINANCING",
    BUY_CAR = "BUY_CAR",
    BUY_OTHER_VESSELS = "BUY_OTHER_VESSELS",
    REFURBISHMENT = "REFURBISHMENT",
    BILL_PAYMENTS = "BILL_PAYMENTS",
    TRAVEL_OR_LEISURE = "TRAVEL_OR_LEISURE",
    HEALTH = "HEALTH",
    ENERGY_MEASURES = "ENERGY_MEASURES",
    OTHER = "OTHER"
}
export enum EstimateModelOrigin {
    EIENDOMSVERDI = "EIENDOMSVERDI",
    CUSTOMER = "CUSTOMER"
}
export enum EstimateModelPriceType {
    ESTIMATE = "ESTIMATE",
    SALES_PRICE = "SALES_PRICE"
}
export enum FundTransferReasonType {
    INTERNET_PURCHASE = "INTERNET_PURCHASE",
    INHERITANCE_OR_GIFTS = "INHERITANCE_OR_GIFTS",
    FAMILY = "FAMILY",
    OTHER = "OTHER"
}
export enum LoanModelOrigin {
    SDC = "SDC",
    CUSTOMER = "CUSTOMER"
}
export enum PersonPUMResponseModelLegitimizeStatus {
    NOT_LEGITIMIZED = "NOT_LEGITIMIZED",
    LEGITIMIZED = "LEGITIMIZED"
}
export enum ProductType {
    SAVINGS_ACCOUNT = "SAVINGS_ACCOUNT",
    CURRENT_ACCOUNT_WITHOUT_CARD = "CURRENT_ACCOUNT_WITHOUT_CARD",
    CURRENT_ACCOUNT_WITH_CARD = "CURRENT_ACCOUNT_WITH_CARD"
}
export enum PurposeOfAccount {
    SAVINGS = "SAVINGS",
    ACCOUNT_CARD = "ACCOUNT_CARD"
}
export enum SelfServiceBankAccessToForeignPaymentsModelForeignPaymentAccessReason {
    GIFT = "GIFT",
    FAMILY = "FAMILY",
    PURCHASE = "PURCHASE",
    OTHER = "OTHER"
}
export enum SelfServiceBankAccessToForeignPaymentsModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankAccountForChildModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankCloseAccountModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankIdForChildModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankOrderAccountStatementsDeliveryMethod {
    ELECTRONIC = "ELECTRONIC",
    POSTAL = "POSTAL"
}
export enum SelfServiceBankOrderAccountStatementsSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModelCertificateType {
    CUSTOMER_CONFIRMATION = "CUSTOMER_CONFIRMATION",
    CERTIFICATE_OF_GOODNESS = "CERTIFICATE_OF_GOODNESS"
}
export enum SelfServiceBankOrderGoodnessCertificateOrCustomerDeclarationModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankOrderPUMModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankPUMForChildModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankRenewFixedRateDepositInputModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankSharedAccountModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankSwitchModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceBankTerminateBSUAccountModelBsuAccountTerminateReason {
    PURCHASE_HOUSING = "PURCHASE_HOUSING",
    REPAYMENT_MORTGAGE = "REPAYMENT_MORTGAGE",
    APPROVED_HOUSING_PURPOSE = "APPROVED_HOUSING_PURPOSE",
    NON_APPROVED_HOUSING_PURPOSE = "NON_APPROVED_HOUSING_PURPOSE"
}
export enum SelfServiceBankTerminateBSUAccountModelBsuAccountTransferOption {
    OWN_STOREBRAND_BANK_ACCOUNT = "OWN_STOREBRAND_BANK_ACCOUNT",
    OWN_EXTERNAL_BANK_ACCOUNT = "OWN_EXTERNAL_BANK_ACCOUNT",
    OTHER_PERSON = "OTHER_PERSON"
}
export enum SelfServiceBankTerminateBSUAccountModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceCreditCardApplicationModelCreditCardApplicationType {
    APPLY_FOR_NEW_CREDIT_CARD = "APPLY_FOR_NEW_CREDIT_CARD",
    INCREASE_CREDIT_LIMIT = "INCREASE_CREDIT_LIMIT",
    DECREASE_CREDIT_LIMIT = "DECREASE_CREDIT_LIMIT",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD"
}
export enum SelfServiceCreditCardApplicationModelCreditCardType {
    STANDARD = "STANDARD",
    PLATINUM = "PLATINUM"
}
export enum SelfServiceCreditCardApplicationModelRelationshipStatus {
    MARRIED = "MARRIED",
    SINGLE = "SINGLE",
    COHABITANT = "COHABITANT",
    REGISTERED_PARTNER = "REGISTERED_PARTNER"
}
export enum SelfServiceCreditCardApplicationModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceCreditCardDetailsModelCreditCardType {
    STANDARD = "STANDARD",
    PLATINUM = "PLATINUM"
}
export enum SelfServiceCreditCardTerminateModelCreditCardTerminateReason {
    LOST = "LOST",
    NO_LONGER_NEEDED = "NO_LONGER_NEEDED",
    MOVING_TO_ANOTHER_BANK = "MOVING_TO_ANOTHER_BANK",
    OTHER = "OTHER"
}
export enum SelfServiceCreditCardTerminateModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceCreditDecreaseModelCreditCardApplicationType {
    APPLY_FOR_NEW_CREDIT_CARD = "APPLY_FOR_NEW_CREDIT_CARD",
    INCREASE_CREDIT_LIMIT = "INCREASE_CREDIT_LIMIT",
    DECREASE_CREDIT_LIMIT = "DECREASE_CREDIT_LIMIT",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD"
}
export enum SelfServiceCreditDecreaseModelCreditCardType {
    STANDARD = "STANDARD",
    PLATINUM = "PLATINUM"
}
export enum SelfServiceLoanAccountModelAccountType {
    CHECKING_ACCOUNT = "CHECKING_ACCOUNT",
    SAVINGS_ACCOUNT = "SAVINGS_ACCOUNT",
    FOREIGN_CURRENCY_ACCOUNT = "FOREIGN_CURRENCY_ACCOUNT",
    HOUSE_CREDIT_ACCOUNT = "HOUSE_CREDIT_ACCOUNT",
    MASTERCARD = "MASTERCARD",
    LOAN = "LOAN",
    GUARANTEE_ACCOUNT = "GUARANTEE_ACCOUNT",
    CLIENT_ACCOUNT = "CLIENT_ACCOUNT",
    OTHER = "OTHER"
}
export enum SelfServiceLoanPaymentAccountModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceLoanPaymentAmountModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceLoanPaymentDateModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceLoanRepaymentPeriodModelSelfServiceType {
    CHANGE_LOAN_TO_INTEREST_ONLY = "CHANGE_LOAN_TO_INTEREST_ONLY",
    CHANGE_LOAN_REPAYMENT_PERIOD = "CHANGE_LOAN_REPAYMENT_PERIOD",
    CHANGE_LOAN_PAYMENT_ACCOUNT = "CHANGE_LOAN_PAYMENT_ACCOUNT",
    CHANGE_LOAN_PAYMENT_DATE = "CHANGE_LOAN_PAYMENT_DATE",
    CHANGE_LOAN_PAYMENT_AMOUNT = "CHANGE_LOAN_PAYMENT_AMOUNT",
    CHANGE_BANK_CLOSE_ACCOUNT = "CHANGE_BANK_CLOSE_ACCOUNT",
    CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS = "CHANGE_BANK_ACCESS_TO_FOREIGN_PAYMENTS",
    CHANGE_BANK_SHARED_ACCOUNT = "CHANGE_BANK_SHARED_ACCOUNT",
    CHANGE_BANK_ORDER_PUM = "CHANGE_BANK_ORDER_PUM",
    CREDIT_CARD_APPLICATION = "CREDIT_CARD_APPLICATION",
    CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT = "CHANGE_BANK_RENEW_FIXED_RATE_DEPOSIT_ACCOUNT",
    ORDER_BANK_ACCOUNT_STATEMENT = "ORDER_BANK_ACCOUNT_STATEMENT",
    ORDER_BANK_SWITCH = "ORDER_BANK_SWITCH",
    ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION = "ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARATION",
    ORDER_BSU_ACCOUNT_TERMINATION = "ORDER_BSU_ACCOUNT_TERMINATION",
    TERMINATE_CREDIT_CARD = "TERMINATE_CREDIT_CARD",
    INCREASE_CREDIT_CARD_LIMIT = "INCREASE_CREDIT_CARD_LIMIT",
    DECREASE_CREDIT_CARD_LIMIT = "DECREASE_CREDIT_CARD_LIMIT",
    ORDER_PUM_FOR_CHILD = "ORDER_PUM_FOR_CHILD",
    ORDER_BANK_ID_FOR_CHILD = "ORDER_BANK_ID_FOR_CHILD",
    ORDER_BANK_ACCOUNT_FOR_CHILD = "ORDER_BANK_ACCOUNT_FOR_CHILD"
}
export enum SelfServiceRenewAccountFrequency {
    THREE_MONTHS = "THREE_MONTHS",
    SIX_MONTHS = "SIX_MONTHS"
}
export enum SourceOfCitizenship {
    CUSTOMER_MASTER = "CUSTOMER_MASTER",
    CUSTOMER = "CUSTOMER",
    INFOTORG = "INFOTORG"
}
export enum SourceOfIncome {
    SALARY = "SALARY",
    STUDENT_SUPPORT = "STUDENT_SUPPORT",
    SOCIAL_BENEFITS = "SOCIAL_BENEFITS",
    INHERITANCE_OR_GIFTS = "INHERITANCE_OR_GIFTS",
    INVESTMENTS = "INVESTMENTS"
}
